<template>
  <div class="processDetail">
    <header>
      <div class="goback" @click="$emit('hide')">
        <i class="el-icon-back"></i>
        返回
      </div>
    </header>
    <div v-if="!processDetailInfo" v-loading="processDetailInfo" class="empty"></div>
    <div v-ps v-else class="detailContent">
      <div
        class="status-info"
        :class="{
          pending: processDetailInfo.status == '进行中',
          completed: processDetailInfo.status == '完成'
        }"
      >
        <i v-if="processDetailInfo.status == '进行中'" class="el-icon-time icon-status"></i>
        <i v-else-if="processDetailInfo.status == '完成'" class="el-icon-success icon-status"></i>
        <i v-else-if="processDetailInfo.status == '执行错误'" class="el-icon-error icon-status"></i>
        <div class="status-text">{{ processDetailInfo.status }}</div>
        <div class="triggerTitle">{{ processDetailInfo.triggerTitle }}</div>
        <div class="errorMsg">{{ processDetailInfo.errorMsg }}</div>
        <div class="time">
          {{
            processDetailInfo.actInstList[processDetailInfo.actInstList.length - 1].endTime ||
              processDetailInfo.actInstList[processDetailInfo.actInstList.length - 1].startTime
          }}
        </div>
      </div>
      <div class="log-info">
        <div class="title">日志</div>
        <ul class="log-list">
          <li
            v-for="(item, index) in processDetailInfo.actInstList"
            :key="index"
            @click="openSubProcess(item)"
            :class="item.subProcess ? 'pointer' : ''"
          >
            <div class="status">
              <i v-if="item.status == '进行中'" class="el-icon-time icon-status"></i>
              <i v-else-if="item.status == '完成'" class="el-icon-success icon-status"></i>
              <i v-else-if="item.status == '执行失败'" class="el-icon-error icon-status"></i>
              <span class="status-text">{{ item.status }}</span>
            </div>
            <div class="flowInfo">{{ item.name }}</div>
            <div class="resMsg"><long-msg-popper :value="item.msg"></long-msg-popper></div>
            <div class="retry">
              <el-button v-if="item.isObject" type="text" @click="reSync(item.executionId)">
                重新执行
              </el-button>
            </div>
            <div class="operationTime">
              <div class="startTime">{{ item.startTime }}</div>
              <div class="endTime">{{ item.endTime }}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <subprocess-dialog ref="subprocess"></subprocess-dialog>
  </div>
</template>

<script>
import SubprocessDialog from "@/views/Backend/AdminEdit/Workflow/components/SubprocessDialog"
import LongMsgPopper from "@/components/BaseComponents/LongMsgPopper"
import { deepClone } from "@/utils/common"
import { retryServiceTaskSync } from "@/api/workflow/workflow"
export default {
  name: "processDetail",
  components: { SubprocessDialog, LongMsgPopper },
  props: {
    processDetail: Object
  },
  computed: {
    processDetailInfo() {
      let process = deepClone(this.processDetail)
      process.actInstList = process.actInstList?.map(item => {
        return Object.assign({}, item, this.getExtra(item.resMsg))
      })
      return process
    }
  },
  methods: {
    openSubProcess(item) {
      if (item.subProcess) {
        this.$nextTick(() => {
          this.$refs.subprocess?.open(item)
        })
      }
    },
    getExtra(value) {
      let isObject = false
      let msg = ""
      let executionId = ""
      let messageList = value?.split(";").filter(item => item) || []
      if (messageList.length) {
        try {
          let obj = JSON.parse(messageList[messageList.length - 1])
          isObject = !!(typeof obj === "object" && obj)
          if (isObject) {
            executionId = obj.executionId
          }
        } catch (e) {
          isObject = false
        }
      }
      messageList?.forEach(item => {
        let itemIsObject = false
        try {
          let itemObject = JSON.parse(item)
          itemIsObject = !!(typeof itemObject === "object" && itemObject)
        } catch (e) {
          itemIsObject = false
        }
        msg = msg + (itemIsObject ? JSON.parse(item).msg : item) + "<br /><br />"
      })

      return {
        isObject,
        msg,
        executionId
      }
    },
    reSync(executionId) {
      retryServiceTaskSync(executionId).then(() => this.$message.success("操作成功"))
    }
  }
}
</script>

<style lang="scss" scoped>
.processDetail {
  display: flex;
  flex-flow: column;
  height: 100%;
  header {
    line-height: 60px;
    border-bottom: 1px solid #ddd;
    .goback {
      display: inline-block;
      cursor: pointer;
      padding: 0 24px;
      .el-icon-back {
        margin-right: 4px;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }
  .empty {
    height: 100px;
  }
  .detailContent {
    flex: 1;
    padding: 24px;
    .status-info {
      display: flex;
      align-items: center;
      padding: 0 24px;
      height: 90px;
      border-radius: 6px;
      &.pending {
        background-color: #e7f3fd;
      }
      &.completed {
        background-color: #e5f9f1;
      }
      .icon-status {
        font-size: 48px;
        vertical-align: middle;
        margin-right: 10px;
      }
      .el-icon-time {
        color: #2195f3;
      }
      .el-icon-success {
        color: #01ca83;
      }
      .el-icon-error {
        color: #ca3820;
      }
      .status-text {
        font-size: 14px;
        font-weight: 600;
      }
      .triggerTitle {
        margin-left: 40px;
        font-size: 18px;
        font-weight: 550;
        flex: 1 1;
      }
      .errorMsg {
        margin-right: 40px;
        font-size: 15px;
        flex: 2 1;
      }
      .time {
        font-size: 15px;
        color: #757575;
      }
    }
    .log-info {
      .title {
        padding: 12px 0;
        border-bottom: 1px solid #ddd;
        font-weight: 550;
        font-size: 16px;
        color: #757575;
      }
      .log-list {
        font-size: 13px;
        color: #333;
        line-height: 1.5;
        li {
          display: flex;
          list-style: none;
          align-items: center;
          padding: 10px 0;
          padding-left: 20px;
          border-bottom: 1px solid #ddd;
          .status {
            display: flex;
            align-items: center;
            min-width: 120px;
            .status-text {
              font-size: 14px;
              font-weight: 600;
            }
            .icon-status {
              font-size: 30px;
              margin-right: 10px;
            }
            .el-icon-time {
              color: #2195f3;
            }
            .el-icon-success {
              color: #01ca83;
            }
            .el-icon-error {
              color: #ca3820;
            }
          }
          .flowInfo {
            display: flex;
            align-items: center;
            flex: 2 1;
            font-size: 16px;
          }
          .resMsg {
            flex: 2 1;
            ::v-deep {
              .el-popover__reference {
                width: 56px;
              }
            }
          }
          .retry {
            flex: 2 1;
          }
          .operationTime {
            min-width: 160px;
            color: #757575;
            .endTime {
              margin-top: 8px;
            }
          }
        }
        li:last-child {
          border: none;
        }
      }
    }
  }
}
</style>
